"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.upsertMemorizedPayeeRule = exports.getMemorizedRule = exports.checkSplitItemSize = exports.getCOAType = exports.categoryCOAObject = exports.getSplitCategoryNames = exports.INTERNAL_CATEGORIES = exports.OLD_BALANCE_ADJUSTMENT = exports.OLD_UNCATEGORIZED_ID = exports.TRANSFER_CATEGORY_ID = exports.UNCATEGORIZED_ID = void 0;
const uuid_1 = require("uuid");
const accounts_1 = require("companion-app-components/flux/accounts");
const redux_store_1 = __importDefault(require("companion-app-components/utils/redux-store"));
const transactions_1 = require("companion-app-components/flux/transactions");
const chart_of_accounts_1 = require("companion-app-components/flux/chart-of-accounts");
const memorized_rules_1 = require("companion-app-components/flux/memorized-rules");
const utils_1 = require("containers/Settings/ChildPages/MemorizedPayee/utils");
exports.UNCATEGORIZED_ID = '0';
exports.TRANSFER_CATEGORY_ID = '21';
exports.OLD_UNCATEGORIZED_ID = '20';
exports.OLD_BALANCE_ADJUSTMENT = '1000';
const { BALANCE_ADJUSTMENT: BAL_ADJUSTMENT, OPENING_BALANCE, TRANSFER, CREDIT_CARD_PAYMENT, } = chart_of_accounts_1.chartOfAccountsTypes.BalanceAdjustmentTypeEnum;
exports.INTERNAL_CATEGORIES = [
    exports.OLD_UNCATEGORIZED_ID,
    exports.TRANSFER_CATEGORY_ID,
    BAL_ADJUSTMENT,
    exports.OLD_BALANCE_ADJUSTMENT,
    OPENING_BALANCE,
    TRANSFER,
    CREDIT_CARD_PAYMENT, // '3'
];
const { mkMemorizedRule } = memorized_rules_1.memorizedRulesTypes;
const { ACCOUNT, BALANCE_ADJUSTMENT, CATEGORY, UNCATEGORIZED } = chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum;
function getSplitCategoryNames(txn) {
    var _a;
    const splitItems = (_a = txn === null || txn === void 0 ? void 0 : txn.split) === null || _a === void 0 ? void 0 : _a.items;
    if (!splitItems) {
        return 'SPLIT';
    }
    const itemsArray = Array.isArray(splitItems) ? splitItems : splitItems.toArray();
    return itemsArray
        .map((item) => chart_of_accounts_1.chartOfAccountsSelectors.getCoaStringSelector(undefined, item === null || item === void 0 ? void 0 : item.coa, true))
        .filter(Boolean)
        .join(', ');
}
exports.getSplitCategoryNames = getSplitCategoryNames;
const categoryCOAObject = (coa) => {
    let { id, type } = coa || {};
    if ((coa === null || coa === void 0 ? void 0 : coa.id) === exports.OLD_UNCATEGORIZED_ID || (coa === null || coa === void 0 ? void 0 : coa.id) === '') {
        // Uncategorized
        id = '0';
        type = UNCATEGORIZED;
    }
    else if ((coa === null || coa === void 0 ? void 0 : coa.id) === exports.TRANSFER_CATEGORY_ID) {
        // Transfer
        type = ACCOUNT;
        id = '0';
    }
    else if ((coa === null || coa === void 0 ? void 0 : coa.id) === exports.INTERNAL_CATEGORIES[3] || // Adjustment
        (coa === null || coa === void 0 ? void 0 : coa.id) === exports.INTERNAL_CATEGORIES[4] || // Opening Balance
        (coa === null || coa === void 0 ? void 0 : coa.id) === exports.INTERNAL_CATEGORIES[5] || // External Transfer
        (coa === null || coa === void 0 ? void 0 : coa.id) === exports.INTERNAL_CATEGORIES[6]) {
        // Credit Card Payment
        type = BALANCE_ADJUSTMENT;
        if ((coa === null || coa === void 0 ? void 0 : coa.id) === exports.INTERNAL_CATEGORIES[3]) {
            id = '0';
        }
        else if ((coa === null || coa === void 0 ? void 0 : coa.id) === exports.INTERNAL_CATEGORIES[4]) {
            id = '1';
        }
        else if ((coa === null || coa === void 0 ? void 0 : coa.id) === exports.INTERNAL_CATEGORIES[5]) {
            id = '2';
        }
        else {
            id = '3';
        }
    }
    return { id, type };
};
exports.categoryCOAObject = categoryCOAObject;
const getCOAType = (categoryId) => {
    let type;
    if (categoryId === exports.UNCATEGORIZED_ID || categoryId === '20' || categoryId === '') {
        // Uncategorized
        type = UNCATEGORIZED;
    }
    else if (categoryId === exports.TRANSFER_CATEGORY_ID) {
        // Transfer
        type = ACCOUNT;
    }
    else if (categoryId === exports.INTERNAL_CATEGORIES[3] || // Adjustment
        categoryId === exports.INTERNAL_CATEGORIES[4] || // Opening Balance
        categoryId === exports.INTERNAL_CATEGORIES[5] || // External Transfer
        categoryId === exports.INTERNAL_CATEGORIES[6]) {
        // Credit Card Payment
        type = BALANCE_ADJUSTMENT;
    }
    else {
        type = CATEGORY;
    }
    return type;
};
exports.getCOAType = getCOAType;
const getCOAObject = (categoryId) => {
    const account = accounts_1.accountsSelectors.getAccountById(redux_store_1.default === null || redux_store_1.default === void 0 ? void 0 : redux_store_1.default.getState(), categoryId);
    const coa = { id: categoryId, type: account ? ACCOUNT : (0, exports.getCOAType)(categoryId) };
    return (0, exports.categoryCOAObject)(coa);
};
const checkSplitItemSize = (items, size = 0) => ('size' in items && items.size > size) || ('length' in items && items.length > size);
exports.checkSplitItemSize = checkSplitItemSize;
const getMemorizedRule = (transaction) => {
    var _a, _b, _c, _d, _e, _f;
    const memorizedRule = {
        clientId: `${(0, uuid_1.v4)().toUpperCase()}`,
        payee: (_a = transaction.payee) !== null && _a !== void 0 ? _a : '',
        transactionType: transaction.amount > 0 ? 'DEPOSIT' : 'PAYMENT',
        memo: (_b = transaction.memo) !== null && _b !== void 0 ? _b : '',
        amount: (_c = transaction.amount) === null || _c === void 0 ? void 0 : _c.toString(),
        markAsCleared: transaction.state === 'CLEARED',
        tags: (transaction === null || transaction === void 0 ? void 0 : transaction.tags) || [],
        split: undefined,
    };
    //  if splits appends splits to the rule
    const splitItems = (_d = transaction.split) === null || _d === void 0 ? void 0 : _d.items;
    let normalizedSplits = [];
    if (Array.isArray(splitItems)) {
        normalizedSplits = splitItems;
    }
    else if (splitItems && 'toArray' in splitItems) {
        normalizedSplits = splitItems.toArray();
    }
    const filteredSplits = normalizedSplits.filter(({ amount = 0 }) => Math.abs(amount) > 0);
    if (filteredSplits && (0, exports.checkSplitItemSize)(filteredSplits, 1)) {
        const splits = filteredSplits.map((split) => {
            var _a, _b;
            return ({
                clientId: `${(0, uuid_1.v4)()}`.toUpperCase(),
                amount: split.amount,
                memo: split === null || split === void 0 ? void 0 : split.memo,
                coa: (split === null || split === void 0 ? void 0 : split.coa) || getCOAObject(((_a = split === null || split === void 0 ? void 0 : split.coa) === null || _a === void 0 ? void 0 : _a.id) ? (_b = split === null || split === void 0 ? void 0 : split.coa) === null || _b === void 0 ? void 0 : _b.id : exports.UNCATEGORIZED_ID),
                tags: (split === null || split === void 0 ? void 0 : split.tags) || null,
            });
        });
        return Object.assign(Object.assign({}, memorizedRule), { split: { items: splits }, tags: [] });
    }
    // If not split append coa object
    const coa = (transaction === null || transaction === void 0 ? void 0 : transaction.coa) || getCOAObject(((_e = transaction === null || transaction === void 0 ? void 0 : transaction.coa) === null || _e === void 0 ? void 0 : _e.id) ? (_f = transaction === null || transaction === void 0 ? void 0 : transaction.coa) === null || _f === void 0 ? void 0 : _f.id : exports.UNCATEGORIZED_ID);
    return Object.assign(Object.assign({}, memorizedRule), { coa });
};
exports.getMemorizedRule = getMemorizedRule;
const upsertMemorizedPayeeRule = (transactions, state) => {
    if (transactions.length === 0) {
        return;
    }
    const memorizedRules = [];
    transactions.forEach((transaction) => {
        var _a;
        if (!transaction.payee || transaction.isDeleted) {
            return;
        }
        // check applied ruleId is available then use it ti fetch MemRule
        const rule = transaction.ruleId
            ? memorized_rules_1.memorizedRulesSelectors.getMemorizedRuleById(state, transaction.ruleId)
            : null;
        if (rule) {
            if (!rule.isNotEditableByTransactions && !(0, utils_1.isComplexRule)(rule)) {
                const memorizedRule = (0, exports.getMemorizedRule)(transaction);
                memorizedRule.id = rule.id;
                memorizedRules.push(memorizedRule);
            }
        }
        else {
            // try find rules by payee name 
            const rulesByPayee = memorized_rules_1.memorizedRulesSelectors.getMemRulesByPayeeName(state, (_a = transaction.payee) !== null && _a !== void 0 ? _a : '');
            // check if any rule has same category as the transaction below 
            const sameCoaRule = rulesByPayee.find((payee) => {
                const isTxnSplit = transactions_1.transactionsUtils.isSplitTxn(transaction);
                const isRuleSplit = transactions_1.transactionsUtils.isSplitTxn(payee);
                // If both are not splits normal COA compare
                if (!isTxnSplit && !isRuleSplit) {
                    return chart_of_accounts_1.chartOfAccountsUtils.coasAreEqual(transaction.coa, payee.coa);
                }
                // if both are split compare the coa of splits
                if (isTxnSplit && isRuleSplit) {
                    return transactions_1.transactionsUtils.splitCoaAreEqual(transaction.split, payee.split);
                }
                // Either one of them is non split so, they are not equal
                return false;
            });
            // We must not memorize a txn which has same COA object as existing complex memorized rule
            // As QCS does not check for the same COA, it creates a new normal rule with same COA 
            if (sameCoaRule && (0, utils_1.isComplexRule)(sameCoaRule)) {
                return;
            }
            // There can be only 1 normal rule, so find the normal from out of all rules with same payee name
            const normalRule = rulesByPayee.find((ruleItem) => !(0, utils_1.isComplexRule)(ruleItem));
            // other than conditional rules only one rule is allowed irrespective of locked status
            // if any locked rule exists, do nothing. Because creating also updates the existing rule with lock.
            if (normalRule && normalRule.isNotEditableByTransactions) {
                return;
            }
            const memorizedRule = (0, exports.getMemorizedRule)(transaction);
            if (normalRule) {
                memorizedRule.id = normalRule.id;
            }
            memorizedRules.push(memorizedRule);
        }
    });
    if (memorizedRules.length > 0) {
        redux_store_1.default === null || redux_store_1.default === void 0 ? void 0 : redux_store_1.default.dispatch(memorized_rules_1.memorizedRulesActions.combineMemorizedRules(memorizedRules.map(mkMemorizedRule)));
    }
};
exports.upsertMemorizedPayeeRule = upsertMemorizedPayeeRule;
